import React, { useState } from 'react';
import { Link } from "react-router-dom";
import logo from '../../assets/logo.png';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar">
      <div className="logo-container">
        <div style={{display:'flex', alignItems:'center'}}>
          <img src={logo} alt="Logo not found" className="logo" />
          <p style={{fontSize:"25px", paddingLeft:'12px', color:'#E2E2B6', fontWeight:'900'}}>Zest Pack Technology</p>
        </div>
        <button className="menu-toggle" onClick={toggleMenu}>
          ☰
        </button>
      </div>
      <ul className={`nav-links ${isOpen ? "open" : ""}`}>
        <li><Link to="/" className="nav-item" onClick={toggleMenu}>Home</Link></li>
        <li><Link to="/about" className="nav-item" onClick={toggleMenu}>About</Link></li>
        <li><Link to="/services" className="nav-item" onClick={toggleMenu}>Services</Link></li>
        {/* <li><Link to="/course" className="nav-item" onClick={toggleMenu}>Courses</Link></li> */}
        <li><Link to="/contact" className="nav-item" onClick={toggleMenu}>Contact</Link></li>
      </ul>
    </nav>
  );
}

export default Navbar;